import { render, staticRenderFns } from "./prescriptionList.vue?vue&type=template&id=35179c9a&scoped=true&"
import script from "./prescriptionList.vue?vue&type=script&lang=js&"
export * from "./prescriptionList.vue?vue&type=script&lang=js&"
import style0 from "./prescriptionList.vue?vue&type=style&index=0&id=35179c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35179c9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35179c9a')) {
      api.createRecord('35179c9a', component.options)
    } else {
      api.reload('35179c9a', component.options)
    }
    module.hot.accept("./prescriptionList.vue?vue&type=template&id=35179c9a&scoped=true&", function () {
      api.rerender('35179c9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/library/components/prescriptionList.vue"
export default component.exports